var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_13114)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_32_13114)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_32_13114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2797 12.5394L10.8512 8.53939M7.0417 8.53939L2.61315 12.5394M2.27979 5.20605L7.72306 9.01635C8.16384 9.32489 8.38424 9.47917 8.62397 9.53892C8.83572 9.59171 9.05719 9.59171 9.26894 9.53892C9.50866 9.47917 9.72906 9.32489 10.1698 9.01635L15.6131 5.20605M5.47978 13.8728H12.4131C13.5332 13.8728 14.0932 13.8728 14.5211 13.6548C14.8974 13.463 15.2034 13.1571 15.3951 12.7807C15.6131 12.3529 15.6131 11.7929 15.6131 10.6728V6.40605C15.6131 5.28595 15.6131 4.72589 15.3951 4.29807C15.2034 3.92175 14.8974 3.61579 14.5211 3.42404C14.0932 3.20605 13.5332 3.20605 12.4131 3.20605H5.47978C4.35968 3.20605 3.79963 3.20605 3.37181 3.42404C2.99549 3.61579 2.68953 3.92175 2.49778 4.29807C2.27979 4.72589 2.27979 5.28595 2.27979 6.40605V10.6728C2.27979 11.7929 2.27979 12.3529 2.49778 12.7807C2.68953 13.1571 2.99549 13.463 3.37181 13.6548C3.79963 13.8728 4.35968 13.8728 5.47978 13.8728Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_13114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.946777 0.539062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_32_13114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.946777 0.539062)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_32_13114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.946777 0.539062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.99ec5c8e065deb4c01b004372554d3c5.svg";
export { ForwardRef as ReactComponent };